import type {TranslationKey} from 'common/i18n';
import type {Theme} from 'common/report/queries/app-api/themes';
import {activeColorScheme} from 'common/util/colors';

export const INLINE_THEME_NAME_KEY: TranslationKey = `chart-customization.custom-theme`;

export const MIN_THEME_COLORS = 4;
export const MAX_THEME_COLORS = 16;

export const MIXPANEL_DEFAULT_THEME_ID = `$mp-default`;

/** @todo finalize color lists */
export const STATIC_THEMES: Theme[] = [
  {
    name: `Mixpanel`,
    id: MIXPANEL_DEFAULT_THEME_ID,
    type: `categorical`,
    data: {
      colors: activeColorScheme.charts.default.map((color) => color.primary),
    },
  },
  {
    name: `Purple`,
    id: `$mp-purple`,
    type: `categorical`,
    data: {
      colors: [
        `#23104E`,
        `#311772`,
        `#3D1E90`,
        `#562FC9`,
        `#5F39D7`,
        `#6945E8`,
        `#7F5EFF`,
        `#8C6CFF`,
        `#9A7BFF`,
        `#B69CFF`,
        `#C5AFFF`,
        `#D3C1FF`,
      ],
      darkColors: [
        `#DACBFF`,
        `#CBB8FF`,
        `#B9A0FF`,
        `#A488FF`,
        `#8B6BFF`,
        `#8060FF`,
        `#734DF9`,
        `#643CE2`,
        `#562FC9`,
        `#4B26AF`,
        `#3F1B9A`,
        `#391786`,
      ],
    },
  },
  {
    name: `Lava`,
    id: `$mp-lava`,
    type: `categorical`,
    data: {
      colors: [
        `#690837`,
        `#861534`,
        `#A22131`,
        `#D23B31`,
        `#E14E3D`,
        `#EA5A45`,
        `#FF7B5F`,
        `#FF8C74`,
        `#FF9C89`,
        `#FFB5A9`,
        `#FFC1B5`,
        `#FFCEC2`,
      ],
      darkColors: [
        `#FFCEC2`,
        `#FFC1B5`,
        `#FFB5A9`,
        `#FF9C89`,
        `#FF8C74`,
        `#FF7B5F`,
        `#EA5A45`,
        `#E14E3D`,
        `#D23B31`,
        `#A22131`,
        `#861534`,
        `#690837`,
      ],
    },
  },
  {
    name: `Mint`,
    id: `$mp-mint`,
    type: `categorical`,
    data: {
      colors: [
        `#123D35`,
        `#0F5D50`,
        `#0C806E`,
        `#07A88F`,
        `#1EC6A7`,
        `#4ED3C4`,
        `#73DED5`,
        `#8FE7E1`,
        `#A3ECE7`,
        `#B5F2F2`,
        `#CAF9F9`,
        `#D7FCFC`,
      ],
      darkColors: [
        `#E3FFFF`,
        `#CCFAFA`,
        `#B5F2F2`,
        `#A3ECE7`,
        `#8FE7E1`,
        `#73DED5`,
        `#4ED3C4`,
        `#1EC6A7`,
        `#07A88F`,
        `#0C806E`,
        `#0F5D50`,
        `#123D35`,
      ],
    },
  },
  {
    name: `Deuteranopia`,
    id: `$mp-deuteranopia`,
    type: `categorical`,
    data: {
      colors: [
        `#011B73`,
        `#4039FF`,
        `#25C1E1`,
        `#4DF3E3`,
        `#88FFB3`,
        `#448E51`,
        `#FFEA00`,
        `#FF6F00`,
        `#C33737`,
        `#730112`,
        `#B0815F`,
        `#FFB987`,
      ],
      darkColors: [
        `#2457FF`,
        `#7773FF`,
        `#5EE4FF`,
        `#86FFF3`,
        `#6EDD88`,
        `#438C51`,
        `#FFED26`,
        `#FF8426`,
        `#CE5353`,
        `#AE021C`,
        `#E7A97C`,
        `#FFE3CE`,
      ],
    },
  },
  {
    name: `Protanopia`,
    id: `$mp-protanopia`,
    type: `categorical`,
    data: {
      colors: [
        `#FFF066`,
        `#E7C415`,
        `#AB7450`,
        `#A22D25`,
        `#640000`,
        `#958AE2`,
        `#5128A4`,
        `#AFFDF4`,
        `#05C995`,
        `#DD98DD`,
        `#B169B0`,
        `#77537F`,
      ],
      darkColors: [
        `#FFFD94`,
        `#FFD818`,
        `#C9916C`,
        `#D54D43`,
        `#874A4A`,
        `#9B8AFF`,
        `#7161CB`,
        `#D3FFFA`,
        `#02A07C`,
        `#B778C6`,
        `#F19FF0`,
        `#FFE8FF`,
      ],
    },
  },
  {
    name: `Tritanopia`,
    id: `$mp-tritanopia`,
    type: `categorical`,
    data: {
      colors: [
        `#CAFFFC`,
        `#43E9E6`,
        `#2677F8`,
        `#000BD3`,
        `#0DB801`,
        `#8FD018`,
        `#D3FC1E`,
        `#F2FF65`,
        `#FF6161`,
        `#E40264`,
        `#820043`,
        `#4A041F`,
      ],
    },
  },
  {
    name: `Focus`,
    id: `$mp-focus-1`,
    type: `categorical`,
    data: {
      colors: [
        `#FF7B5F`,
        `#37375C`,
        `#41416D`,
        `#4B4B7E`,
        `#55558E`,
        `#5D5DA3`,
        `#6565B4`,
        `#7070CA`,
        `#7979DF`,
        `#8686ED`,
        `#9595F1`,
        `#AAAAF9`,
      ],
    },
  },
];
